import { Injectable } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ErrorChangeAccountMsgEng } from '../../../custom-header/header.constants';
import * as config from '../../config/app.config';
import { BaseService } from '../../services/base.service';
import { ShipToToAddress, UserAccountAddressDetails } from '../../model/addresses.model';

@Injectable({
  providedIn: 'root',
})
export class LocationStripService {
  userAccountType: any;
  userAccountData = new BehaviorSubject<any>(false);
  userAccountData$ = this.userAccountData.asObservable();
  saveAccount: any;
  errorMessageText: string = ErrorChangeAccountMsgEng;
  public userAccountDetails = new BehaviorSubject<any>(false);
  userAccountDetails$ = this.userAccountDetails.asObservable();
  public userAccountAddressDetails = new Subject<UserAccountAddressDetails>();
  userAccountAddressDetails$ = this.userAccountAddressDetails.asObservable();
  public endSession = new BehaviorSubject<any>(false);
  endSession$ = this.endSession.asObservable();

  $shipToAddress = new Subject<ShipToToAddress>();

  constructor(
    private readonly baseService: BaseService,
    private readonly globalMessage: GlobalMessageService
  ) {
    this.saveAccount = new Subject();
  }

  public getUserAccountDataFromDb(userId): void {
    this.baseService
      .get(config.USER_ACCOUNT + userId + '/b2bUnits', { fields: 'FULL' })
      .subscribe((res) => {
        if (res) {
          this.userAccountType = res.type;
          this.userAccountData.next({ res });
        }
      });
  }

  public getUserAccountAddressesDataFromDb(userId): void {
    this.userAccountAddressDetails.next(null);
    if (userId) {
      this.baseService
        .get(config.USER_ACCOUNT + userId + '/accounts', { fields: 'FULL' })
        .subscribe((res) => {
          this.userAccountAddressDetails.next({ res });
        });
    }
  }

  public getShipToToAddress(userId, sapCustomerId): void {
    if (sapCustomerId != undefined) {
      this.baseService
        .get(config.USER_ACCOUNT + userId + '/accounts/' + sapCustomerId, {
          fields: 'FULL',
        })
        .subscribe((res) => {
          if (res) {
            this.$shipToAddress.next({ res });
          }
        });
    }
  }

  public saveSelectedAccount(userId, b2bUnitId): void {
    this.baseService
      .put(config.USER_ACCOUNT + userId + '/selectedUnit/' + b2bUnitId, {
        fields: 'FULL',
      })
      .subscribe(
        (res) => {
          this.saveAccount.next(true);
          location.reload();
        },
        (error) => {
          if (!!error) {
            window.scroll(0, 0);
            this.globalMessage.add(
              this.errorMessageText,
              GlobalMessageType.MSG_TYPE_ERROR
            );
          }
        }
      );
  }

  public saveSelectedShipToAddress(userId, b2bUnitId): void {
    if (b2bUnitId != undefined) {
      this.baseService
        .postBody(
          config.USER_ACCOUNT + userId + '/selected-shipto-unit/',
          b2bUnitId
        )
        .subscribe(
          (res) => {},
          (error) => {
            if (!!error) {
              window.scroll(0, 0);
              this.globalMessage.add(
                this.errorMessageText,
                GlobalMessageType.MSG_TYPE_ERROR
              );
            }
          }
        );
    }
  }
  public disableLocStrip(endSessionFlag): void {
    this.endSession.next(endSessionFlag);
  }
}
